// extracted by mini-css-extract-plugin
module.exports = {"loader":"top-ten-clicks_loader_1EM0G","offersTable":"top-ten-clicks_offersTable_1GdVJ"};